import { Link } from "react-router";

import { formatDateRelative } from "simplydo/core/dates";
import { OpenAPI } from "simplydo/interfaces";

import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

type SmallIdeaCardProps = {
  idea: Pick<
    OpenAPI.Schemas["Idea"],
    "_id" | "name" | "isSubmitted" | "submittedAt" | "updatedAt" | "coverImage"
  > & {
    coverImageUrl?: string | null;
    coverImageThumbnailUrls?: Record<string, string> | null;
  };
  index: number;
};

export const SmallIdeaCard = ({ idea, index }: SmallIdeaCardProps) => {
  return (
    <RowComponent.Cell index={index} key={idea._id} asChild>
      <Link to={`/ideas/${idea._id}`}>
        <div
          style={{
            width: 50,
            height: 40,
            borderRadius: 3,
            flex: "0 0 50px",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundImage: `url(${util.mixinCssUrlFallback(util.ideaCoverImage(idea, "200x200"), util.ideaCoverImage(undefined))})`,
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 5,
            marginRight: 5,
            position: "relative",
            top: -1,
          }}
        >
          <RowComponent.Title wrapping style={{ color: "#5d5d5d" }} block>
            {idea.name}
          </RowComponent.Title>
          <RowComponent.StatusArea>
            {idea.isSubmitted ? (
              <>
                <RowComponent.StatusLabel color="green" />
                Submitted{" "}
                {formatDateRelative(idea.submittedAt, { addSuffix: true })}
              </>
            ) : (
              <>
                <RowComponent.StatusLabel color="yellow" />
                Updated{" "}
                {formatDateRelative(idea.updatedAt, { addSuffix: true })}
              </>
            )}
          </RowComponent.StatusArea>
        </div>
      </Link>
    </RowComponent.Cell>
  );
};

export default SmallIdeaCard;
